export default __webpack_public_path__ + "static/media/map-marker.c16829ee.svg";